<template>
	<nk-page commercialAccess="System" :policyClaims="{ or: ['General_User_Add', 'General_User_Edit'] }">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid h-100 form-container">
			<div class="row flex-row-reverse h-100">
				<div class="col-12 h-100">
					<nk-stabs :activeTab="activeTab" @activeTabChanged="onActiveTabChanged" class="h-100 user-detail-tabs nk-card">
						<nk-stab :id="'basic-info'" :name="$t('user.personalInfo.title')" class="h-100">
							<div class="nk-card">
								<div class="row no-gutters mobile nk-seprator">
									<div class="col-sm-8 col-12">
										<div>
											<nk-col-form-group :label="$t('user.f.isActive') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-switch v-model="localData.isActive" :options="{}" :tabindex="100"></nk-switch>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.firstName') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.firstName" :options="componentOptions.name" :tabindex="101" startup></nk-input>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.lastName') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.lastName" :options="componentOptions.name" :tabindex="102"></nk-input>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.nationalCode') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.nationalCode" :options="componentOptions.name" :maxlength="10" :tabindex="103"></nk-input>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.email') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.email" :options="componentOptions.name" :tabindex="104"></nk-input>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.phoneNumber') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.phoneNumber" :maxlength="20" :options="componentOptions.name" :tabindex="105"></nk-input>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.landLineNumber') + ':'" :labelSizes="{ xs: 12, sm: 3 }" :dataSizes="{ xs: 12, sm: 9 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.landLineNumber" :options="componentOptions.name" :maxlength="20" :tabindex="106" startup></nk-input>
											</nk-col-form-group>
										</div>
									</div>
									<div class="image-container col-12 col-sm-4">
										<nk-image-uploader ref="imageUploader" v-model="localData.imageUrl" />
									</div>
								</div>
								<div class="row no-gutters">
									<div class="col-sm-6 col-12">
										<div>
											<nk-col-form-group :label="$t('user.f.userName') + ':'" :labelSizes="{ xs: 12, sm: 4 }" :dataSizes="{ xs: 12, sm: 8 }" :labelAligns="{ xs: 'right', sm: 'left' }">
												<nk-input v-model="localData.userName" id="install-username" :options="componentOptions.name" @update:modelValue="validateUsername" :tabindex="107" :disabled="!retreiveIsEmpty() ? true : null"></nk-input>
												<div v-if="retreiveIsEmpty()" id="enOrDigits" :class="[{ 'valid': usernameValidations.enOrDigits }, 'd-flex mt-1 hint-text']">
													<p class="px-1">
														{{ $t('install.m.RequireEnLetterOrDigit') }}
													</p>
												</div>
											</nk-col-form-group>
										</div>
										<div>
											<nk-col-form-group :label="$t('user.f.oldPassword') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }" v-if="NeedOldPassword">
												<nk-input v-model="localData.oldPassword" :options="componentOptions.password" tabindex="108" />
											</nk-col-form-group>
										</div>
									</div>
								</div>
								<div class="row no-gutters nk-seprator">
									<div class="col-sm-6 col-12">
										<nk-col-form-group class="position-relative" :label="$t('user.f.password') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
											<nk-input @input="validatePassword" id="id_password" v-model="localData.password" :options="componentOptions.password" :autocomplete="false" class="id_password" tabindex="109" />
											<i @click="showPassword" id="togglePassword" class="far fa-eye eye"></i>
											<div v-if="passwordValidations.showPasswordValildators" id="moreThan8Char" :class="[{ 'valid': passwordValidations.moreThan8Chars }, 'd-flex hint-text']">
												<p class="px-1">
													{{ $t('install.m.PasswordTooShort') }}
												</p>
											</div>
											<div v-if="passwordValidations.showPasswordValildators" id="useSymbol" :class="[{ 'valid': passwordValidations.useSymbol }, 'd-flex hint-text symbol']">
												<p class="px-1">
													{{ $t('install.m.useSymbol') }}
												</p>
											</div>
											<div v-if="passwordValidations.showPasswordValildators" id="useUpperCase" :class="[{ 'valid': passwordValidations.useUpperCase }, 'd-flex hint-text']">
												<p class="px-1">
													{{ $t('install.m.useUpperCase') }}
												</p>
											</div>
										</nk-col-form-group>
									</div>
									<div class="col-sm-6 col-12">
										<nk-col-form-group :label="$t('user.f.confirmPassword') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
											<nk-input @input="validatePassword" v-model="localData.confirmPassword" :options="componentOptions.password" class="id_password" tabindex="110" />
											<div v-if="passwordValidations.showPasswordValildators" id="confirmPassword" :class="[{ 'valid': passwordValidations.matchConfirm }, 'd-flex mt-1 hint-text']">
												<p class="px-1">
													{{ $t('install.m.confirmPassword') }}
												</p>
											</div>
										</nk-col-form-group>
									</div>
								</div>
								<div class="row no-gutters">
									<div class="col-sm-6 col-12">
										<nk-col-form-group :label="$t('user.f.postalCode') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
											<nk-input v-model="localData.postalCode" :options="componentOptions.name" :maxlength="10" :tabindex="111"></nk-input>
										</nk-col-form-group>
										<nk-col-form-group :label="$t('user.f.expirationDate') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
											<nk-date v-model="localData.expirationDate" :options="componentOptions.date" :tabindex="112"></nk-date>
										</nk-col-form-group>
									</div>
									<div class="col-sm-6 col-12">
										<nk-col-form-group :label="$t('user.f.address') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
											<nk-textarea :rows="5" :tabindex="113" v-model="localData.address"></nk-textarea>
										</nk-col-form-group>
									</div>
								</div>
							</div>
						</nk-stab>
						<nk-stab :id="'claims'" :name="$t('user.userInfo.claims-and-roles')">
							<div class="d-flex flex-column h-100 form-container">
								<nk-col-form-group class="nk-card" :label="$t('user.userInfo.roles') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 10 }">
									<nk-multichoice2 v-if="activeTab === 'claims'" v-model="selectedRoles" :data="operationRoles" :options="componentOptions.multiChoice" @update:modelValue="refreshOperationClaims" tabindex="114" class="w-100"></nk-multichoice2>
								</nk-col-form-group>
								<nk-table class="nk-card mt-2" v-model="selectedClaimRow" :data="operationClaims" :options="componentOptions.claimTable" tabindex="115" ref="claimTable"></nk-table>
							</div>
						</nk-stab>
						<nk-stab :id="'companies-periods'" :name="$t('user.userInfo.companies-and-periods')">
							<div class="d-flex flex-column h-100 form-container">
								<div>
									<Tree v-model:data="treeData" :options="componentOptions.treeOptions" ref="tree" @change="TreeItemChanged" />
								</div>
							</div>
						</nk-stab>
						<nk-stab :id="'user-change-log'" :name="$t('user.userInfo.user-change-log')">
							<nk-change-log class="change-log" :options="changeLog" tabindex="115" />
						</nk-stab>
					</nk-stabs>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Dropdown from '~/components/general/dropdown.vue'
	import Tree from '~/components/checkbox-tree/Tree.vue'

	import validators, {
		Checker,
		VRequiredIf,
		VRequiredIfValue,
		VCustom,
		isEmpty,
	} from '~/statics/validators'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import emptyId from '~/statics/empty-id'
	import { mapActions, mapGetters, mapState } from 'vuex'
	import Endpoints from '@nikan/endpoints'

	export default {
		modal: {
			size: 'lg',
			stateUID: 'user-modify',
			helpTag: 'UserModify'
		},
		components: {
			Tree,
		},
		props: {
			data: { type: Object, required: true },
			options: {
				type: Object,
			},
		},
		data() {
			return {
				settings: {
					needOldPassword: false,
				},
				passwordValidations: {
					moreThan8Chars: false,
					useSymbol: false,
					useUpperCase: false,
					matchConfirm: false,
					showPasswordValildators: false,
				},
				usernameValidations: {
					enOrDigits: false,
				},
				originalData: null,
				localData: {
					isActive: true,
					id: emptyId,
					firstName: '',
					lastName: '',
					nationalCode: '',
					postalCode: '',
					landLineNumber: '',
					phoneNumber: '',
					address: '',
					email: '',
					userName: '',
					oldPassword: '',
					password: '',
					confirmPassword: '',
					userRoleNames: [],
					operationRoles: [],
					dedicateOperationAccesses: [],
					accessibleCompanyFiscalPeriods: [],
				},
				componentOptions: {
					name: {
						required: true,
					},
					date: {
						pickerEnabled: true,
						pickerCss: 'btn btn-default',
						defaultValue: null,
						emptyValue: null
					},
					multiChoice: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return item.name
						},
						searchableFields: ['name'],
					},
					treeOptions: {
						isCompanyPeriodTree: true,
						treeDirection: 'rtl',
						checkboxOptions: {
							checkedColor: '#466eb5',
							unCheckedColor: 'white'
						}
					},
					password: {
						type: 'password',
						mode: 'password'
					},
					claimTable: {
						stateUID: 'claimsTable',
						editable: true,
						itemSize: 30,
						alwaysEmit: true,
						searchable: true,
						searchBarEnabled: true,
						displayOrderEnabled: false,
						addNewRowOnInit: false,
						colIndicatorBarEnabled: false,
						prepareLockedRow: (row, rowIndex, data) => {
							return !row.isDedicate
						},
						buttons: {
							addBtn: {
								handler: this.addClaimRow,
								options: {
									visible: true,
								},
							},
							deleteBtn: {
								handler: this.deleteClaimRow,
								options: {
									visible: true,
								},
							},
						},
						prepareNewRow: () => {
							return {
								id: emptyId,
								operationClaim: null,
								isDedicate: true,
								rowState: 'new',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: '...',
								reverseDir: false,
								searchable: false,
								sortable: true,
								editable: false,
								resizable: false,
								pinnable: false,
								pinned: true,
								entering: (row) => {
									return false
								},
								width: '60px|>60px',
							},
							{
								name: 'operationClaim',
								title: this.$t('operationRole.claim'),
								align: 'right',
								search: {
									useTranslate: true,
									searchFields: ['key'],
									prefix: 'operationClaims.',
									translateSplitter: "",
								},
								view: {
									options: {
										format: (item) => {
											return this.$t(`operationClaims.${item.key}`)
										},
									},
								},
								edit: (row, col) => {
									return {
										component: Dropdown,
										options: {
											selectorWidth: '300px',
											selectorHeight: 300,
											rowIdentifier: 'id',
											getDataFromOptions: true,
											locateSelectorBasedOnDocument: true,
											searchableFields: ['key'],
											searchPrefix: 'operationClaims',
											lowerCaseSearch: false,
											display: (item) => {
												return this.$t(`operationClaims.${item.key}`)
											},
											data: this.filterOperationClaims,
										},
									}
								},
								searchable: true,
								sortable: true,
								editable: true,
								validators: validators('required'),
								autoGrowWidth: true,
								width: 'auto|>300px',
							},
						],
					},
				},
				validators: {
					firstName: validators('required'),
					lastName: validators('required'),
					nationalCode: validators('ir-national-code'),
					postalCode: validators('ir-postal-code'),
					email: validators('required', 'email'),
					userName: validators('required'),
					oldPassword: validators(
						new VCustom(
							(val, obj) => {
								if (!obj) {
									return false
								}

								if (
									!isEmpty(obj.id) &&
									obj.password &&
									this.options.needOldPassword === true
								) {
									if (isEmpty(obj.oldPassword)) {
										return false
									}
								}

								return true
							},
							(oldPassword) => {
								return this.$t('msg.required', [oldPassword])
							}
						)
					),
					password: validators(
						new VRequiredIfValue('id', (val) => {
							return isEmpty(val)
						})
					),
					confirmPassword: validators(new VRequiredIf('password')),
				},
				selectedRoles: null,
				selectedClaimRow: null,
				selectedCompanyPeriods: [],
				activeTab: 'basic-info',
				allOperationRoles: [],
				allOperationClaims: [],
				operationClaims: [],
				treeData: [],
			}
		},
		computed: {
			...mapState('appContext', {
				status: (state) => state,
			}),
			...mapGetters({
				fiscalPeriods: 'fiscalPeriods/all',
			}),
			changeLog() {
				return {
					entityTitle: this.$t('change-log.f.user-log-title', {
						user: this.localData.userName,
					}),
					userId: this.localData.id,
					title: false,
				}
			},
			NeedOldPassword() {
				return this.settings.needOldPassword
			},
			operationRoles() {
				return this.allOperationRoles.filter((x) => x.dedicatedUser == null)
			},
			filterOperationClaims() {
				var data = this.$refs.claimTable.getTableData()
				if (!data.success) {
					return []
				}
				var toBeExcludeIds = data.data
					.filter((x) => x.operationClaim)
					.map((x) => x.operationClaim.id)
				return this.allOperationClaims.filter((x) => {
					return toBeExcludeIds.indexOf(x.id) === -1
				})
			},
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
			this.localData = _.extend({}, this.localData, this.data)
		},
		mounted() {
			this.getUserData(this.localData.id).then((res) => {
				this.selectedRoles = res.operationRoles.filter((role) => role.dedicatedUser === null)
				this.localData = res
				this.originalData = _.cloneDeep(this.localData)
				this.operationClaims = res.operationAccesses
					.filter((x) => x.operationRole && x.operationRole.dedicatedUser)
					.map((x) => {
						x.isDedicate = true
						return x
					})

				let user = this.retreiveIsEmpty() ? this.$t('new') : this.localData.userName
				this.prepareWindow(this.$t('user.user-modify.title', { name: this.localData.firstName + ' ' + this.localData.lastName, user: user }), [
					{
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						isPrimary: true,
						icon: 'save',
						handle: (button, page, e) => {
							this.save()
						},
						policyClaims: { or: ['General_User_Add', 'General_User_Edit'] },
					},
				])

				this.loadAllOperationRoles().then((results) => {
					let fetchedRoles = []

					this.allOperationRoles = results
					this.allOperationRoles.filter(x => this.selectedRoles.map(y => {
						if (x.id === y.id) fetchedRoles.push(x)
					}))

					this.selectedRoles = fetchedRoles
				})

				this.loadOperationClaims().then((results) => {
					this.allOperationClaims = results
				})

				if (this.retreiveIsEmpty())
					this.passwordValidations.showPasswordValildators = true

				this.prepareTreeData()
			})
		},
		methods: {
			...mapActions('appContext', {
				appContextRefresh: 'refresh',
			}),
			...mapActions('fiscalPeriods', {
				refreshFiscalPeriods: 'refresh',
			}),
			showPassword() {
				const togglePassword = $('#togglePassword')
				const type = this.componentOptions.password.mode == 'password' ? 'text' : 'password'
				this.componentOptions.password = {
					type: type,
					mode: type
				}
				togglePassword.toggleClass('fa-eye-slash')
			},
			validateUsername() {

				if (!this.retreiveIsEmpty()) // skip username validation on edit
					for (var key of Object.keys(this.usernameValidations))
						this.usernameValidations[key] = true

				else
					this.usernameValidations.enOrDigits = !!this.localData.userName && !!this.localData.userName.match('[a-zA-z0-9]*')

				return Object.values(this.usernameValidations).every(x => x === true)
			},
			validatePassword() {
				this.passwordValidations.showPasswordValildators = true
				const password = this.localData.password

				if (!this.retreiveIsEmpty() && (!password || !password.length) && (!this.localData.confirmPassword || !this.localData.confirmPassword.length))
					for (var key of Object.keys(this.passwordValidations))
						this.passwordValidations[key] = true

				else {
					this.passwordValidations.moreThan8Chars = password && password.length >= 8
					this.passwordValidations.useUpperCase = !!password && password.length && !!password.match('.*[A-Z].*')
					this.passwordValidations.useSymbol = !!password && password.length && !!password.match('(?=.*?[#?!@$%^&*-])')
					this.passwordValidations.matchConfirm = password === this.localData.confirmPassword
				}

				return Object.values(this.passwordValidations).every(x => x === true)
			},
			stateSyncer() {
				let originalRoles = this.originalData.operationRoles.filter((role) => role.dedicatedUser === null)
				let final = []

				if (_.isEqual(originalRoles, this.selectedRoles)) return this.localData.operationRoles = this.selectedRoles

				this.selectedRoles.filter(x => originalRoles.findIndex(y => y.id === x.id) === -1).map(role => {
					role.rowState = 'new'
					final.push(role)
				})

				originalRoles.filter(x => this.selectedRoles.findIndex(y => y.id === x.id) === -1).map(role => {
					role.rowState = 'deleted'
					final.push(role)
				})

				this.localData.operationRoles = _.merge(this.originalData.operationRoles, final)
			},
			treeSyncer() {
				let originalItems = this.originalData?.accessibleCompanyFiscalPeriods
				let selectedItems = this.selectedCompanyPeriods
				let final = []

				if (selectedItems.length > 0) {
					selectedItems.forEach(selected => {
						let matched = originalItems.find(item =>
							item.entityId === selected.entityId && item.entityType === selected.entityType
						)
						final.push({
							id: matched ? matched.id : emptyId,
							entityId: selected.entityId,
							entityType: selected.entityType,
							delete: false
						})
					})

					originalItems.forEach(item => {
						let stillSelected = selectedItems.some(selected =>
							selected.entityId === item.entityId && selected.entityType === item.entityType
						)
						if (!stillSelected) {
							final.push({
								id: item.id,
								entityId: item.entityId,
								entityType: item.entityType,
								delete: true
							})
						}
					})
				}

				this.localData.accessibleCompanyFiscalPeriods = final
			},
			valueChanged(val) { },
			getUserData(userId) {
				if (userId === emptyId) {
					return Promise.resolve(this.localData)
				}

				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.grandParent)
					var url = Endpoints.getUrl('user.get', userId)
					post(url, { userId: userId, IncludeRoles: true })
						.then((result) => {
							wait.end()
							result.data.isActive = result.data.isActive === false ? false : true

							this.validateUsername()
							this.validatePassword()
							resolve(result.data)
						})
						.catch((error) => {
							wait.end()
						})
				})
			},
			loadAllOperationRoles() {
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('operationRole.list'), { LoadRelatedData: true, includeDedicate: true })
						.then((result) => {
							resolve(result.data.items)
						})
						.catch(() => {
							// wait.end()
						})
				})
			},
			loadOperationClaims() {
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('operationClaim.list'), {})
						.then((result) => {
							resolve(result.data.items)
						})
						.catch(() => {
							// wait.end()
						})
				})
			},
			async prepareTreeData() {
				try {
					if (!this.fiscalPeriods?.length) {
						await this.refreshFiscalPeriods()
					}

					const res = await post(Endpoints.getUrl('companies.list'), null)
					const companies = res.success ? res.data.items : []

					this.treeData = companies.map(company => {
						const periods = this.fiscalPeriods.filter(period => period.companyId === company.id)
						return {
							id: company.id,
							text: company.name,
							state: { isChecked: false, disabled: false },
							children: periods.map(period => ({
								id: period.id,
								text: period.name,
								state: { isChecked: false, disabled: true }
							}))
						}
					})

					await this.$nextTick()
					setTimeout(() => {
						this.restoreTreeSelections()
					}, 100)

					return this.treeData
				} catch (error) {
					console.error('Error preparing tree data:', error)
					this.treeData = []
					return []
				}
			},
			TreeItemChanged() {
				let selected = []

				this.treeData.forEach(company => {
					if (company.state && company.state.isChecked === true) {
						selected.push({
							entityId: company.id,
							entityType: 'Company'
						})
					}
					if (company.children && Array.isArray(company.children)) {
						company.children.forEach(period => {
							if (period.state && period.state.isChecked === true) {
								selected.push({
									entityId: period.id,
									entityType: 'FiscalPeriod'
								})
							}
						})
					}
				})
				this.selectedCompanyPeriods = selected
			},
			restoreTreeSelections() {
				if (!this.treeData || !this.localData.accessibleCompanyFiscalPeriods) return
				let selectedItems = this.localData.accessibleCompanyFiscalPeriods

				selectedItems.forEach(item => {
					if (item.entityType === 'Company') {
						let company = this.treeData.find(c => c.id === item.entityId)
						if (company && company.state) {
							company.state.isChecked = true
						}
					}
					if (item.entityType === 'FiscalPeriod') {
						this.treeData.forEach(company => {
							if (company.children && Array.isArray(company.children)) {
								let period = company.children.find(p => p.id === item.entityId)
								if (period && period.state) {
									period.state.isChecked = true
									period.state.disabled = false
									if (company.state) {
										company.state.isChecked = true
										company.children.forEach(p => (p.state.disabled = false))
									}
								}
							}
						})
					}
				})
			},
			async save() {

				if (!this.validateUsername() || !this.validatePassword()) {
					this.validationToast([{ key: 'product', error: this.$t('user.m.fix-validation-errors') }])
					return
				}

				return new Promise(async (resolve, reject) => {
					var url
					var that = this
					this.stateSyncer()
					this.treeSyncer()

					await this.$refs.claimTable
						.commitChanges()
						.then((records) => {
							this.localData.operationAccesses = records.filter(
								(x) => x.operationClaim && x.isDedicate
							)
						})
						.catch((err) => {
						})

					if (isEmpty(this.localData.id))
						url = Endpoints.getUrl('user.create')
					else
						url = Endpoints.getUrl('user.update')

					if (this.validateInputs()) {
						var wait = this.$wait(this.grandParent)
						let data = {
							imageFileBase64: this.$refs.imageUploader.getUploadImageDataBase64(),
							user: this.localData,
							password: this.localData.password,
							confirmPassword: this.localData.confirmPassword,
						}
						// uploader.uploadHandler(data, () => (event) => {
						// 	this.progress = Math.round((100 * event.loaded) / event.total)
						// }, url).then((response) => {
						// 	wait.end()

						// 	if (this.localData.id === this.status.user.id)
						// 		this.appContextRefresh({ force: true })

						// 	if (response.success) {
						// 		this.$toast(this.$t('msg.create-success'), { type: 'success' })
						// 		that.resolve(response.data)
						// 	}
						// })
						// 	.catch((error) => {
						// 		wait.end()
						// 	})

						post(url, data).then((response) => {
							wait.end()

							if (this.localData.id === this.status.user.id)
								this.appContextRefresh({ force: true })

							if (response.success) {
								this.$toast(this.$t('msg.create-success'), { type: 'success' })
								that.resolve(response.data)
							}
						})
							.catch((error) => {
								wait.end()
							})
					}
				})
			},
			onActiveTabChanged(tabid) {
				this.activeTab = tabid
				if (tabid === 'claims') {
					this.refreshOperationClaims()
				}
			},
			validateInputs() {
				let checker = new Checker((prop) => this.$t(`user.f.${prop}`))
				let errors = checker.test(this.localData, this.validators)

				this.validationToast(errors)
				return errors.length === 0
			},
			retreiveIsEmpty() {
				if (isEmpty(this.localData.id)) {
					return true
				} else {
					return false
				}
			},
			addClaimRow(button, e) {
				e.preventDefault()

				if (!this.$refs.claimTable) return

				this.$refs.claimTable.col_setActiveCol('operationClaim')
				this.$refs.claimTable.row_tryAddEmptyAt(0, true, true)
			},
			deleteClaimRow(button, e) {
				e.preventDefault()
				if (!this.$refs.claimTable) return

				this.$refs.claimTable.row_deleteSelectedRows()
			},
			refreshOperationClaims() {
				let list = this.operationClaims.filter((x) => x.isDedicate)
				let operationRoles = this.selectedRoles
				for (var i = 0; i < operationRoles.length; i++) {
					for (var j = 0; j < operationRoles[i].operationClaims.length; j++) {
						if (list.findIndex((x) => x.id === operationRoles[i].operationClaims[j].id) === -1) {
							operationRoles[i].operationClaims[j].isDedicate = false
							list.push({
								id: emptyId,
								operationClaim:
									operationRoles[i].operationClaims[j],
							})
						}
					}
				}

				this.operationClaims = _.orderBy(list, ['isDedicate'], ['asc'])
			},
		},
	}
</script>
<style>
	.user-detail-tabs .nk-stabs-panels {
		height: 92%;
		overflow-y: auto;
		overflow-x: hidden;
		background-color: #f2f3f8;
	}

	.user-detail-tabs .eye {
		position: absolute;
		top: 6px;
		left: 8px;
		color: #aaa !important;
	}

	.user-detail-tabs .eye:hover {
		cursor: pointer;
		color: black !important;
	}

	.user-detail-tabs .fa-eye-slash {
		color: black !important;
	}

	.user-detail-tabs .change-log .h-grow-lock {
		min-height: unset;
		min-width: unset;
		overflow-y: auto;
	}

	.user-detail-tabs .role-tab {
		background: #f2f3f8;
		padding: 10px !important;
	}

	@media screen and (max-width: 767px) {
		.mobile {
			flex-direction: column-reverse;
		}

		.nk-page .nk-seprator::after {
			display: none;
		}

		.image-container {
			margin-right: auto;
			margin-left: auto;
		}
	}
</style>
